import { makeVar, ReactiveVar } from '@apollo/client'

import { ITag } from 'shared/interfaces'
import { TMergeArgs } from 'shared/types'

import { mergePagination } from 'shared/utils/storePagination'
import { Feed } from 'shared/__gql-types'

export const FeedStore = {
  projectFeed: {
    read: () => projectFeedVar()
  },
  projectFeedFilter: {
    read: () => projectFeedFilterVar()
  },
  feed: {
    read: () => feedVar()
  },
  getFeedsByCampaignId: {
    keyArgs: [],
    merge: <T extends object>(existing: T, incoming: T, { args }: TMergeArgs) =>
      mergePagination('feeds', existing, incoming, args?.offset)
  },
  getFeeds: {
    keyArgs: [],
    merge: <T extends object>(existing: T, incoming: T, { args }: TMergeArgs) =>
      mergePagination('feeds', existing, incoming, args?.offset)
  },
  galleryPreviews: {
    read: () => galleryPreviewsVar()
  },
  galleryUrls: {
    read: () => galleryUrlsVar()
  },
  galleryLoading: {
    read: () => galleryLoadingVar()
  }
}

export const projectFeedVar: ReactiveVar<Feed[]> = makeVar<Feed[]>([])
export const feedVar: ReactiveVar<Feed[]> = makeVar<Feed[]>([])
export const projectFeedFilterVar: ReactiveVar<ITag[]> = makeVar<ITag[]>([])
export const galleryPreviewsVar: ReactiveVar<File[]> = makeVar<File[]>([])
export const galleryUrlsVar: ReactiveVar<string[]> = makeVar<string[]>([])
export const galleryLoadingVar: ReactiveVar<boolean> = makeVar<boolean>(false)
